import script from "./ESIMBundles.vue?vue&type=script&lang=ts&setup=true"
export * from "./ESIMBundles.vue?vue&type=script&lang=ts&setup=true"

import "./ESIMBundles.vue?vue&type=style&index=0&id=e0b0f47e&lang=scss"

const __exports__ = script;

export default __exports__